(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ReportExecuteDialogController', ReportExecuteDialogController);

    ReportExecuteDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ReportExecute', 'Report', 'ReportCondition'];

    function ReportExecuteDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ReportExecute, Report, ReportCondition) {
        var vm = this;

        vm.reportExecute = entity;
        vm.clear = clear;
        vm.save = save;
        vm.reports = Report.query();
        vm.reportconditions = ReportCondition.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.reportExecute.id !== null) {
                ReportExecute.update(vm.reportExecute, onSaveSuccess, onSaveError);
            } else {
                ReportExecute.save(vm.reportExecute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:reportExecuteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
